var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap-box",class:{'selected-box': _vm.idx == _vm.selectIdx},on:{"click":_vm.onclick}},[_c('div',[_vm._v("주"+_vm._s(_vm.idx + 1))]),_vm._v(" "),_c('div',{staticClass:"noti_title"},[_vm._v(_vm._s(_vm.item.dongNm.trim()))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.item.etcPurps))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d5fb15a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/controls/BrItem.vue
// module id = null
// module chunks = 